<template lang="html">
  <div class="input-border first">
    <label for="value"></label>
    <span class="text">Finální cena</span>
    <div class="group">
      <div class="border-gr short">
        <input name="value" type="text" autocomplete="false"
               v-on:input="$emit('print-final-price', $event.target.value)"
               :value="finalPrice" />
      </div>
    </div>
  </div>

  <TheValueCurrency
      :discount-currency="discountCurrency"
      @apply-discount-currency="applyDiscountCurrency"
  />
</template>

<script>
import TheValueCurrency from "@/components/UIComponents/PromocodeComponents/Configuration/Promocode/TheValueCurrency";
export default {
  components: {TheValueCurrency},
  emits: ['print-final-price', 'print-discount-currency'],
  props: [
    'applierId', 'finalPrice', 'discountCurrency'
  ],
  name: "TheFinalPrice",
  methods: {
    applyDiscountCurrency(value) {
      this.$emit(
          'print-discount-currency',
          value
      );
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/styles/_variables.scss";
@import "@/assets/styles/_promocode.scss";
</style>